export default __webpack_public_path__ + "static/media/noa-37.427761fa.jpg";